document.addEventListener('DOMContentLoaded', function () {
  var overlay = document.getElementById('email-popup-overlay');
  var closeBtn = document.getElementById('email-popup-close');
  var form = document.getElementById('email-popup-newsletter-form');
  var formState = document.getElementById('email-popup-form-state');
  var successState = document.getElementById('email-popup-success-state');

  if (!overlay) return;

  var STORAGE_KEY = 'paddockVintagePopupSeen';

  // Zobrazit popup po 3 vteřinách, pokud ho zákazník ještě neviděl
  if (!sessionStorage.getItem(STORAGE_KEY)) {
    setTimeout(function () {
      overlay.classList.add('is-visible');
    }, 3000);
  }

  function closePopup() {
    overlay.classList.remove('is-visible');
    sessionStorage.setItem(STORAGE_KEY, 'true');
  }

  closeBtn.addEventListener('click', closePopup);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);

      fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      }).then(function () {
        formState.style.display = 'none';
        successState.style.display = 'block';
        sessionStorage.setItem(STORAGE_KEY, 'true');
      }).catch(function () {
        // I při chybě zobrazíme kód, ať zákazník neodejde naprázdno
        formState.style.display = 'none';
        successState.style.display = 'block';
      });
    });
  }
});